export const getSelectOptions = (data:any) => {
    if (!data || data === undefined) return [];
    const options = data.map((option:any) => {
      return { label: option?.clientName, value: option.id };
    });
    return options;
  };
  export const getSelectUserOptions = (data:any) => {
    if (!data || data === undefined) return [];
    const options = data.map((option:any) => {
      return { label: option?.userName, value: option.userId };
    });
    return options;
  };
  export function formatBytes(bytes:any, decimals = 0) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
export const NonEmptyString = (value: string | undefined) => {
  return value !== "" && value !== null && value !== undefined;
};

export const isEmpty = (value: string | undefined) => {
  return value === "" || value === null || value === undefined;
};
export const trimString = (value: string) => {
  return value.trim();
};

export const ltrimString = (value: string) => {
  return value.trimStart();
};
export function getNumbersAndDecimals(n: string | number) {
  if (n === null || n === undefined || n === "") {
    return 0;
  }
  const decPart = (n + "").split(".")[1];
  return decPart?.length || 0;
}